var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncognitoBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V6.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6423 15.0469L13.0468 12.6424C12.7572 12.4187 12.3941 12.2856 11.9998 12.2856C11.0531 12.2856 10.2856 13.0531 10.2856 13.9999C10.2856 14.3941 10.4186 14.7573 10.6423 15.0469Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V7.75H2ZM9.28027 18.5303C8.98738 18.8232 8.51251 18.8232 8.21961 18.5303C7.92672 18.2374 7.92672 17.7626 8.21961 17.4697L8.89008 16.7992C8.34756 16.3915 7.86862 15.9307 7.47422 15.5025C6.68177 14.642 6.68177 13.358 7.47422 12.4975C8.51921 11.3628 10.1577 10 11.9998 10C12.9953 10 13.9314 10.398 14.7464 10.9429L16.2196 9.46967C16.5125 9.17678 16.9874 9.17678 17.2803 9.46967C17.5732 9.76256 17.5732 10.2374 17.2803 10.5303L9.28027 18.5303ZM11.2145 17.9193L16.5777 12.5561C17.3175 13.4155 17.3001 14.6613 16.5255 15.5025C15.4805 16.6372 13.842 18 11.9998 18C11.7334 18 11.4713 17.9715 11.2145 17.9193Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoBrowser);
export default __webpack_public_path__ + "static/media/incognito-browser.560bd1a20a4f37684ec4a340dd3c46fe.svg";
export { ForwardRef as ReactComponent };